import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import Header from './components/Header';
import Partner from './components/Partner';
import Forms from './components/Forms';
import VerificationComponent from './components/how_redeem';
import Footer from './components/Footer';
import ResultPage from './components/ResultPage';
import ContactForm from './components/Contact';

function App() {
  return (
    <BrowserRouter>
      <Header />

      <Routes>
        {/* Route racine : ton formulaire et les autres sections */}
        <Route
          path="/"
          element={
            <>
              <Forms  />
              <br />
              <Partner />
              <VerificationComponent />
            </>
          }
        />

        {/* Route résultat */}
        <Route path="/result" element={<ResultPage />} />

        {/* Route résultat */}
        <Route path="/contact" element={<ContactForm />} />
      </Routes>

      <Footer />
    </BrowserRouter>
  );
}

export default App;
